import * as React from "react";
import { Link } from "react-router-dom";

import "./Footer.css";
import { Box } from "../../components";

const logo: string = require("../../images/logo.png");

interface FooterProps {
  fullWidth?: boolean;
  hasShadow?: boolean;
}

const Footer = (props: FooterProps) => (
  <section className="footer">
    <Box {...props}>
      <div className="row">
        <div className="col-md-9">
          <div className="row">
            <div className="col-md-4">
              <ul>
                <li>
                  <h2>Điều khoản &amp; Chính sách</h2>
                </li>
                <li>
                  <Link to="/pages/terms">Điều khoản sử dụng</Link>
                </li>
                <li>
                  <Link to="/pages/privacy">Chính sách bảo mật</Link>
                </li>
                <li>
                  <Link to="/pages/order">Quy định về giao dịch</Link>
                </li>
              </ul>
            </div>
            <div className="col-md-4">
              <ul>
                <li>
                  <h2>Tuyển dụng</h2>
                </li>
                <li>
                  <Link to="/pages/about">Về chúng tôi</Link>
                </li>
                <li>
                  <Link to="/pages/about">Cơ hội nghề nghiệp</Link>
                </li>
              </ul>
            </div>
            <div className="col-md-4">
              <ul>
                <li>
                  <h2>Hỗ trợ</h2>
                </li>
                <li>
                  <Link to="/pages/qa">Q&amp;A</Link>
                </li>
                <li>
                  <Link to="/pages/about">Dành cho khách hàng tập đoàn</Link>
                </li>
              </ul>
            </div>
            <div className="col-xs-12 bottom">
              <h2 className="underline">Liên hệ</h2>
              <div className="row">
                <div className="col-md-7">
                  <p>
                    <i className="fa fa-map-marker fa-fw" /> Tầng 12, Tòa báo
                    Nông Thôn Ngày Nay, ngõ 68 Dương Đình Nghệ, Yên Hòa, Cầu
                    Giấy, Hà Nội
                  </p>
                </div>
                <div className="col-md-5">
                  <p>
                    <i className="fa fa-phone fa-fw" />{" "}
                    <a href="tel:+842466602466">+84 24-6660-2466</a>
                  </p>
                  <p>
                    <i className="fa fa-envelope fa-fw" />{" "}
                    <a href="mailto:info@expressdesign.vn">
                      info@expressdesign.vn
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="info">
            <img src={logo} />
            <p>
              Tiên phong trong dịch vụ đặt hàng thiết kế trực tuyến tại Việt Nam
            </p>
            <p>© 2006-2017 ExpressDesign.vn</p>

            <ul className="social">
              <li>
                <Link
                  target="_blank"
                  to="https://www.facebook.com/expressdesign.vietnam/"
                >
                  <i className="fa fa-facebook" />
                </Link>
              </li>
              <li>
                <Link
                  target="_blank"
                  to="https://www.youtube.com/channel/UCNK0FxeB_Bl7NFkmrsR5bLw"
                >
                  <i className="fa fa-youtube" />
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Box>
  </section>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/layouts/Main/Footer.tsx